export const trim = (str) => {
    str = str.trim();
    let x = "";
    for (let i=0; i < str.length; i++ ){
        if (str.charCodeAt(i) >= 32) {
            x += str[i];
        }
    }
    return x;
};

